import i1 from './about-01.jpg'
import i2 from './about-02.jpg'
import i3 from './about-03.jpg'
import i4 from './about-04.jpg'
import i6 from './about-06.jpg'

export const page2Images = {
    i1,
    i2,
    i3,
    i4,
    i6
}